//
// Copyright (c) 2017 by Curalate, Inc.
//

/* global angular: false, window: false, CURALATE: false */

(function() {
  angular.module('curalate').service('Like2BuyAnalyticsService', [
    '$http',
    '$q',
    'PromiseService',
    function($http,
                 $q,
                 PromiseService,
        ) {
            // Analytics
      this.getStoreAnalytics = function(storeId, params) {
        params = params || {};
        return PromiseService.processHttpResponse($http.get(`/api/v2/like2buy/${storeId}/analytics`, { params }));
      };

            // Return the URL to download analytics
            // storeId is the store id
            // reportType is either "daily" (for daily summaries) or "item" (for item analytics)
            // params are the date range parameters
      this.getStoreAnalyticsCSVUrl = function(storeId, reportType, params) {
        const paramString = $.param(params);

        switch (reportType) {
                    // original URL -- really need better names
          case 'daily': return `/api/v2/like2buy/${storeId}/analytics.csv${paramString ? `?${paramString}` : ''}`;
          case 'items': return `/api/v2/like2buy/${storeId}/items.csv${paramString ? `?${paramString}` : ''}`;
          case 'products': return `/api/v2/like2buy/${storeId}/products.csv${paramString ? `?${paramString}` : ''}`;
          default: return '';
        }
      };

      this.getStoreEmailsCSVUrl = function(storeId, params) {
        const paramString = $.param(params);
        return `/api/v2/like2buy/${storeId}/emails.csv${paramString ? `?${paramString}` : ''}`;
      };
    }]);
})();
